import { useEffect, useState } from "react";
import PlatformApp from "../platform_spaces/PlatformApp";
import CorporatePortalApp from "./CorporatePortalApp";
import { CorporatePortalApi } from "./CorporatePortalApi";

/** v.longfans.com 始终展示龙粉社，不受单位门户测试模式影响 */
function isLongfansVerifyHost(): boolean {
  if (typeof window === "undefined") {
    return false;
  }
  return window.location.hostname.toLowerCase() === "v.longfans.com";
}

/** 平台站入口：按 Redis 测试模式决定展示龙粉社或单位门户 */
export default function PlatformAppGate() {
  const skipPortal = isLongfansVerifyHost();
  const [portalMode, setPortalMode] = useState<boolean | null>(null);

  useEffect(() => {
    if (skipPortal) {
      return;
    }
    void CorporatePortalApi.getTestModeConfig().then((cfg) => {
      setPortalMode(!!cfg.enabled);
    });
  }, [skipPortal]);

  if (skipPortal) {
    return <PlatformApp />;
  }

  if (portalMode === null) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#f4f7fb",
          color: "#5c6b80",
          fontWeight: 300,
        }}
      >
        加载中…
      </div>
    );
  }

  if (portalMode) {
    return <CorporatePortalApp />;
  }

  return <PlatformApp />;
}
